import { Flag } from "lucide-react";

export const StatusChip = ({
  status,
  fullWidth = false,
  hideIcon = false,
  className = "",
  variant = "default",
}: {
  status: string;
  fullWidth?: boolean;
  hideIcon?: boolean;
  className?: string;
  variant?: "default" | "pastel";
}) => {
  let styles: { bg: string; text: string; icon: string };

  const isPastel = variant === "pastel";

  switch (status) {
    case "Live":
    case "Approved":
    case "Accepted":
    case "Verified":
    case "Complete":
      styles = isPastel
        ? {
            bg: "bg-emerald-200",
            text: "text-slate-700",
            icon: "text-emerald-600 fill-emerald-600",
          }
        : {
            bg: "bg-emerald-700",
            text: "text-white",
            icon: "fill-white",
          };
      break;
    case "Declined":
    case "Snagged":
      styles = isPastel
        ? {
            bg: "bg-rose-200",
            text: "text-slate-700",
            icon: "text-rose-700 fill-rose-700",
          }
        : {
            bg: "bg-rose-700",
            text: "text-white",
            icon: "fill-white",
          };
      break;
    case "Banned":
    case "Awaiting":
    case "Incomplete":
      styles = isPastel
        ? {
            bg: "bg-slate-200",
            text: "text-slate-700",
            icon: "text-slate-700 fill-slate-700",
          }
        : {
            bg: "bg-slate-600",
            text: "text-white",
            icon: "fill-white",
          };
      break;
    case "On Hold":
      styles = isPastel
        ? {
            bg: "bg-blue-200",
            text: "text-slate-700",
            icon: "text-blue-700 fill-blue-700",
          }
        : {
            bg: "bg-blue-700",
            text: "text-white",
            icon: "fill-white",
          };
      break;
    case "DCI Only":
      styles = isPastel
        ? {
            bg: "bg-purple-200",
            text: "text-slate-700",
            icon: "text-purple-600 fill-purple-600",
          }
        : {
            bg: "bg-purple-700",
            text: "text-white",
            icon: "fill-white",
          };
      break;
    case "Pending":
    case "Uploaded":
    case "Review":
    case "Received":
      styles = isPastel
        ? {
            bg: "bg-amber-200",
            text: "text-slate-700",
            icon: "text-amber-600 fill-amber-600",
          }
        : {
            bg: "bg-amber-500",
            text: "text-white",
            icon: "fill-white",
          };
      break;
    case "N/A":
      styles = {
        bg: "bg-transparent",
        text: "text-slate-700",
        icon: "fill-transparent",
      };
      break;
    default:
      styles = isPastel
        ? {
            bg: "bg-primary-50",
            text: "text-slate-700",
            icon: "text-primary fill-primary",
          }
        : {
            bg: "bg-primary-700",
            text: "text-white",
            icon: "fill-white",
          };
      break;
  }

  return status ? (
    <div
      className={`flex items-center justify-center gap-2 rounded-full ${
        styles.bg
      } ${fullWidth ? "w-full" : "w-fit"} px-2 py-[3px] ${className}`}
      title={status}
    >
      {!hideIcon && <Flag className={`${styles.icon}`} size={12} />}
      <span className={`truncate text-xs ${isPastel ? "font-medium" : ""} ${styles.text}`}>{status}</span>
    </div>
  ) : (
    "-"
  );
};
